export function clampMs(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, value));
}

export interface AdaptiveNoteWindows {
  durationMs: number;
  ioiMs: number;
  earlyMs: number;
  lateMs: number;
  sustainTailMs: number;
  lateGraceMs: number;
}

export function computeAdaptiveNoteWindows(durationMs: number, ioiMs: number): AdaptiveNoteWindows {
  const dur = Math.max(60, durationMs);
  const ioi = Math.max(dur, ioiMs, 70);
  return {
    durationMs: dur,
    ioiMs: ioi,
    earlyMs: clampMs(Math.round(ioi * 0.18), 70, 200),
    lateMs: clampMs(Math.round(ioi * 0.38), 100, 340),
    sustainTailMs: clampMs(Math.round(dur * 0.28), 35, 150),
    lateGraceMs: clampMs(Math.round(ioi * 0.22), 60, 180),
  };
}

export type RhythmHitStatus = 'pending' | 'hit' | 'late' | 'miss';

export interface RhythmAttackEvent {
  index: number;
  abcTok: string;
  startMs: number;
  durationMs: number;
  earlyMs: number;
  lateMs: number;
  lateGraceMs: number;
  status: RhythmHitStatus;
  timingErrorMs: number | null;
}

export function attackWindowEndMs(ev: RhythmAttackEvent): number {
  return ev.startMs + ev.lateMs;
}

export function attackHardEndMs(ev: RhythmAttackEvent): number {
  return attackWindowEndMs(ev) + ev.lateGraceMs;
}

export function isInsideAttackWindow(ev: RhythmAttackEvent, tMs: number): boolean {
  return tMs >= ev.startMs - ev.earlyMs && tMs <= attackHardEndMs(ev);
}
